import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { logout } from "../../../redux/adminUser";
import logo from "../../Assets/images/dignity_logo_svg.png";
import { useTranslation } from "react-i18next";

const Sidebar = ({ onToggleSidebar }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // Function to close the sidebar and navigate to the link
  const closeSidebarAndNavigate = (link) => {
    if (isMobile) {
      onToggleSidebar();
    }
    navigate(link); // Navigate to the link
  };

  function Logout() {
    dispatch(logout());
    localStorage.clear();
    navigate("/admin");
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  let location = useLocation();
  const isActive = (pathname) => location.pathname === pathname;
  const isActiveLink = (pathname) => location.pathname.startsWith(pathname);

  return (
    <>
      <div className="dashboard-nav">
        <header className="logo-back mb-1">
          <a
            href="javascript:void(0);"
            className="menu-toggle"
            id="toggleSidebarBtn"
            onClick={onToggleSidebar}
          >
            <i className="fas fa-times"></i>
          </a>
          <div className="logo">
            <img src={logo} alt="" width={100} />
          </div>
        </header>
        <nav className="dashboard-nav-list">
          <Nav className="dashboard-nav-list">
            <Link
              className={`dashboard-nav-item ${
                (isActive("/admin/clients") || isActiveLink("/admin/my-bots/")) ? "admin-active-link" : ""
              }`}
              onClick={() => closeSidebarAndNavigate("/admin/clients")}
              to="/admin/clients"
            >
              <i className="fa-solid fa-user-group"></i> {t("Users")}
            </Link>
            
            <Link
              className={`dashboard-nav-item ${
                isActive("/admin/rate-limit") ? "admin-active-link" : ""
              }`}
              to="/admin/rate-limit"
              onClick={() => closeSidebarAndNavigate("/admin/rate-limit")}
            >
              <i className="fa-solid fa-ban"></i> {t("Rate limit")}
            </Link>
            
            <Link
              className={`dashboard-nav-item ${
                isActive("/admin/setting") ? "admin-active-link" : ""
              }`}
              to="/admin/setting"
              onClick={() => closeSidebarAndNavigate("/admin/setting")}
            >
              <i className="fa-solid fa-gear"></i>
              {t("Default Setting")}
            </Link>
           
            <div className="nav-item-divider" />
            <a className="dashboard-nav-item" onClick={() => Logout()}>
              <i className="fas fa-sign-out-alt" />
              {t("Logout")}
            </a>
          </Nav>
        </nav>
      </div>
    </>
  );
};
export default Sidebar;
